<style>
.category-notification{
    z-index: 5000;
    min-width: 800px;
    margin: 12px -40px 12px 12px;
    float: right;
    padding-left: 100px;
}    

.category-name{
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    padding-left: 8px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
}

.checkbox-container .k-checkbox {
    opacity: 1 !important;
    position: static !important;
    width: 16px !important;
    height: 16px !important;
    margin: 0 8px 0 0 !important;
    display: inline-block !important;
}

input[type="checkbox"]:checked {
  background-color: green !important;
}

.checkbox-container .k-checkbox-label {
    display: none !important;
}

.checkbox-container span {
    cursor: pointer;
}
</style>

<div style="background: white; height: 100vh;" #anchor>
    <div *ngIf="pageLoading" class="loader-div">
        <span class="k-loading-image" style="color: #000000;"></span>
    </div> 
    <div class="ibox-title" style="height: 5vh; padding: 0; border: none;">
        <div class="col-md-12">
            <h2 style="font-weight: 500;">
                <a>Notifications</a> 
            </h2>
        </div>
    </div>
    <div style="height: calc(100vh - 100px);">
        <div class="col-md-12" style="padding-right: 1em;">
            <div class="col-md-11" style="height: 92vh; overflow-y: auto;">
                <div style="margin: 0 100px 0 1em;">
                    <div class="col-md-12 category-notification d-flex row"> 
                        <div class="row col-md-6" *ngFor="let category of categoriesList; let idx=index" data-index="idx">		
                            <div class="col-md-12" style="padding: 15px;">
                                <div *ngIf="category.notificationCategory.length>0" class="checkbox-container">
                                    <input type="checkbox" [id]="'checkbox'+category.name" class="k-checkbox"
                                        style="border-color: rgb(128, 120, 120);"
                                        [disabled]="category?.notificationCategory?.length==0"
                                        [checked]="checkSubNotifications(category)"
                                        (click)="onCategoryclick($event,category)"/>
                                    <label class="k-checkbox-label" [for]="'checkbox'+category.name"></label>
                                    <span class="category-name">{{category.description}}</span>
                                </div>
                                <div *ngIf="category.notificationCategory.length>0">
                                    <div *ngFor="let notificationCategory of category.notificationCategory; let id=index" data-index="id" style="padding-top: 6px; padding-left: 30px;">
                                        <div class="checkbox-container">
                                            <input type="checkbox" [id]="'checkbox'+id" class="k-checkbox"
                                                style="border-color: rgb(128, 120, 120);"
                                                [checked]="userNotificationIdsList.includes(notificationCategory?.notification?.id)"
                                                (click)="onNotificationCheckboxclick($event,notificationCategory?.notification)"/>
                                            <label class="k-checkbox-label" [for]="'checkbox'+id"></label>
                                            <span>{{notificationCategory?.notification?.description}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-1" style="position: absolute; float: right; margin: 0 0 0 calc(100% - 105px);">
                <div kendoTooltip class="row">
                    <button class="btn action-button rail360-primary-item button-round"
                        id="save" title="Save" (click)="saveUserNotificationList()">
                        <i class="fa fa-2x fa-save"></i>
                    </button>              
                </div>
                <div kendoTooltip class="row">
                    <button title="Reset" id="reset"
                        class="btn action-button rail360-danger-item button-round"
                        (click)="resetData()">
                        <i class="fa fa-2x fa-times"></i>
                    </button> 
                </div>                
            </div>
        </div>
    </div>    
</div>